import { PASSWORD_RULES } from "../../utils/password";

// Live password-requirement checklist — each rule turns green as it's satisfied.
export const PasswordChecklist = ({ value = "" }) => (
  <ul className="mt-2 space-y-1">
    {PASSWORD_RULES.map((rule) => {
      const ok = rule.test(value);
      return (
        <li
          key={rule.label}
          className={`flex items-center gap-1.5 text-xs transition-colors ${
            ok ? "text-green-600" : "text-gray-400"
          }`}
        >
          <span className="w-3 text-center">{ok ? "✓" : "○"}</span>
          {rule.label}
        </li>
      );
    })}
  </ul>
);
